<template>
  <div class="srsbody">
    <div class="topbar">
      <span>总数：{{ Total }}</span>
      <el-button type="danger" @click="closeAllChanelSure" :loading="btnLoading"
        >关闭所有通道</el-button
      >
    </div>
    <!-- 列表搜索 -->
    <el-form :inline="true" :model="pages" class="demo-form-inline">
      <el-form-item label="机构名">
        <el-input v-model="pages.orgName" placeholder="请输入机构名"></el-input>
      </el-form-item>
      <el-form-item label="流通道">
        <el-input v-model="pages.stream" placeholder="请输入流通道"></el-input>
      </el-form-item>
      <el-form-item class="btn">
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button @click="resetInput">重置</el-button>
      </el-form-item>
    </el-form>
    <!-- 显示列表 -->
    <el-table
      ref="multipleTable"
      :data="tableData"
      stripe
      style="width: 100%"
      v-loading="tabelLoading"
    >
      <el-table-column label="序号" align="center" width="55" fixed>
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="设备名" prop="deviceName" align="center" sortable> </el-table-column>
      <el-table-column label="机构名	" prop="orgName" align="center" sortable> </el-table-column>
      <el-table-column label="播放量	" prop="playNum" align="center" sortable> </el-table-column>
      <el-table-column label="流通道" prop="stream" align="center" sortable> </el-table-column>
      <el-table-column label="操作" align="center" width="150" fixed="right">
        <template slot-scope="scope">
          <el-button type="danger" @click="closeChanelSure(scope.row.stream)" :loading="btnLoading"
            >关闭通道</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import srsApi from 'api/home/srs-management.js';
export default {
  data() {
    return {
      Total: 0,
      pages: {
        orgName: '',
        stream: ''
      },
      tableData: [],
      tabelLoading: false,
      btnLoading: false
    };
  },
  created() {
    this.getChanelList();
  },
  methods: {
    getChanelList() {
      this.tabelLoading = true;
      srsApi
        .getChanelList(this.pages)
        .then(res => {
          if (res.status === 200) {
            this.Total = res.data.data.channelTotalNum;
            this.tableData = res.data.data.list;
            this.tabelLoading = false;
          }
        })
        .catch(err => {
          this.tabelLoading = true;
        });
    },
    closeChanel(val) {
      this.btnLoading = true;
      srsApi
        .closeChanel({ stream: val })
        .then(res => {
          this.btnLoading = false;
          this.getChanelList();
          this.$message({
            message: '关闭成功',
            type: 'success'
          });
        })
        .catch(err => {
          this.btnLoading = true;
        });
    },
    closeAllChanel() {
      this.btnLoading = true;
      srsApi
        .closeAllChanel()
        .then(res => {
          this.btnLoading = false;
          this.getChanelList();
          this.$message({
            message: '关闭成功',
            type: 'success'
          });
        })
        .catch(err => {
          this.btnLoading = true;
        });
    },
    onSubmit() {
      this.getChanelList();
    },
    resetInput() {
      this.pages = {};
      this.getChanelList();
    },
    closeChanelSure(val) {
      this.$confirm('是否删除该通道, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.closeChanel(val);
        })
        .catch(() => {});
    },
    closeAllChanelSure() {
      this.$confirm('是否删除所有通道, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.closeAllChanel();
        })
        .catch(() => {});
    }
  }
};
</script>
<style lang="less" scpoed>
.srsbody {
  padding: 50px;
}
.topbar {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
</style>